import { browser } from '$app/environment';
import { writable } from 'svelte/store';
import { iOsOrAndroid, isUserFromApp } from '$lib/helpers/device';

export const isAppUser     = writable(false);   // true/false for “is native app?”
export const isAppUserType = writable('unknown'); // 'ios' | 'android' | 'web' | 'unknown'

if (browser) {
  // Check whether we’re inside the WebToNative shell
  isUserFromApp()
    .then(res => isAppUser.set(res === 'app'))
    .catch(err => {
      console.error('isUserFromApp failed:', err);
      isAppUser.set(false);
    });

  // Identify platform if possible
  iOsOrAndroid()
    .then(res => isAppUserType.set(res))  // res = 'ios' | 'android' | 'web'
    .catch(err => {
      console.error('iOsOrAndroid failed:', err);
      isAppUserType.set('unknown');
    });
}
